import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChatApp from './ChatApp';
import AdminApp from './admin/AdminApp';
import LoginPage from './components/LoginPage';
import { isLoggedInAs } from './services/auth';

function UserProtectedRoute({ children }) {
  return isLoggedInAs('user') ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/chat" element={<UserProtectedRoute><ChatApp /></UserProtectedRoute>} />
      <Route path="/admin/*" element={<AdminApp />} />
    </Routes>
  );
}

export default App;
